
import { useContext, useEffect, useState } from "react";
import { PRODUCER_API } from "../../../../Utilities/APIs/APIs";
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";
import Modal from "../../../Partials/Elements/Modal/Modal";
import ArchiveItem from "../../../Partials/Layouts/ArchiveItem/ArchiveItem";
import ArchiveButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ArchiveButton/ArchiveButton";
import CRUDTable from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable";
import ShortTextCell from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell";
import CRUDTableHeader from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDth from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import CRUDTableRow from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow";

import { useParams } from "react-router-dom";
import AppContext from "../../../../Context/AppContext";
import BackButton from "../../../Partials/Elements/BackButton/BackButton";
import CreateButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDashboardBoilerplate/CRUDHeader/CreateButton/CreateButton";
import CreateEventProducer from "./CreateEventProducers";
import DeleteItem from "../../../Partials/Layouts/DeleteItem/DeleteItem";

function EventProducers({

}) {
    
    const { eventId, eventName } = useParams();
    const [employees, setEmployees] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [targetID, setTargetID] = useState(null);
    const [toggleFetch, setToggleFetch] = useState(false);
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [showDeleteSection, setShowDeleteSection] = useState(false);

    const [archive, setArchive] = useState(null);

    const { employee, setIsLoading } = useContext(AppContext);
    const axiosInstance = useAxiosInstance();

    useEffect(() => {
        async function fetchAndSetEmployees() {
            setIsLoading(true)
            const { data } = await axiosInstance.get(`${PRODUCER_API}?event=${eventId}`);
            setEmployees(data);
            setTimeout(() => {
                setIsLoading(false)
            }, 1000);

        }

        fetchAndSetEmployees();
    }, [employee.token, toggleFetch, eventId]);

    function triggerFetch() {
        setToggleFetch((prevState) => !prevState);
    }



    return (
        <>
            <div className="crud_holder">
                <div className="body_header">

                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <BackButton />
                        <h1 className="heading">{`${eventName} - Producers (${employees?.length > 0 ? employees?.length : 0} in total)`}</h1>
                    </div>
                    <CreateButton
                        screenTopicSingular={'Producer'}
                        setShowModal={setShowModal}
                        setShowCreateForm={setShowCreateForm}
                    />
                    {/* <h1 className="heading">{`Employees (${employees?.length > 0 ? employees?.length : 0} in total)`}</h1>
          */}
                </div>
                <CRUDTable>
                    <CRUDTableHeader>
                        <CRUDth th="Event Name" />
                        <CRUDth th="Producer Name" />
                        <CRUDth th="Producer Email" />
                        <CRUDth th="Actions" />
                    </CRUDTableHeader>
                    <tbody>
                        {employees && employees?.map((e) => (
                            <CRUDTableRow key={e._id}>

                                <ShortTextCell text={e.event.name} />
                                <ShortTextCell text={e.producer.name} />
                                <ShortTextCell text={e.producer.email} />

                                {employee.level === "admin" ? (
                                    <td className="action_button_cell">
                                        <ArchiveButton
                                            setShowModal={setShowModal}
                                            setShowDeleteSection={setShowDeleteSection}
                                            targetID={e._id}
                                            isArchive={e.isArchive}
                                            setTargetID={setTargetID}
                                            setArchive={setArchive}
                                            
                                        />
                                    </td>
                                ) : (
                                    ""
                                )}

                            </CRUDTableRow>
                        ))}
                    </tbody>
                </CRUDTable>
            </div>
            {showModal && showDeleteSection && (
                <Modal
                    handleClose={()=>{
                        setShowModal(false)
                        setShowDeleteSection(false)
                    }}
                    modalHeading={showDeleteSection && `Delete Invite`}
                >
                    <DeleteItem
                    
                    />
                    
                        <ArchiveItem
                            api={"archiveEmployee/"}
                            targetID={targetID}
                            setShowModal={setShowModal}
                            setShowDeleteSection={setShowDeleteSection}
                            triggerFetch={triggerFetch}
                            isArchive={archive}
                        />
                </Modal>
            )}

            {showModal && showCreateForm && (
                <Modal
                    handleClose={()=>{
                        setShowModal(false)
                        setShowCreateForm(false)
                    }}
                    modalHeading={showCreateForm && `Create Producer`}
                >
                    
                        <CreateEventProducer
                            employee={employee}
                            setShowCreateForm={setShowCreateForm}
                            setShowModal={setShowModal}
                            triggerFetch={triggerFetch}
                            eventId={eventId}
                        />
                </Modal>
            )}
        </>
    );
}

export default EventProducers;
